import * as React from "react";
import type { SVGProps } from "react";
const SvgTruck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M5.143 17.029h-.914A1.83 1.83 0 0 1 2.4 15.2V6.971c0-1.01.819-1.828 1.829-1.828h8.228c1.01 0 1.829.819 1.829 1.828V15.2c0 1.01-.819 1.829-1.829 1.829h-.914m4.114 0H15.2a.914.914 0 0 1-.914-.915V8.343c0-.505.41-.914.914-.914h2.303c.278 0 .54.126.714.343L21.4 11.75c.13.162.2.363.2.57v3.794c0 .505-.41.915-.914.915m-10.057-.458a2.286 2.286 0 1 1-4.572 0 2.286 2.286 0 0 1 4.572 0Zm9.6 0a2.286 2.286 0 1 1-4.572 0 2.286 2.286 0 0 1 4.572 0Z"
    />
  </svg>
);
export default SvgTruck;
